/* PureEthical - pais e lingua pela localizacao, uma unica vez.

   Usa o /browsing_context_suggestions.json da Shopify, que devolve o
   pais deduzido do IP do visitante.

   DUAS VIAS, e a diferenca e' importante:

   A) O pais detectado E' um mercado activo (FR, DE, IT, ES ou um dos
      23 da UE). Submete-se o formulario de localizacao: a Shopify
      troca mercado e moeda, a pagina recarrega, e o mapa que esta no
      theme.liquid trata da lingua a seguir.

   B) O pais detectado NAO e' um mercado activo (Suica, Reino Unido,
      Estados Unidos, Brasil). Antes o script desistia em silencio e o
      visitante ficava no mercado por defeito - o Europa, cujo idioma
      e' pt-PT. Resultado: um suico ou um ingles via a loja em
      PORTUGUES.
      Agora nao se mexe no mercado nem na moeda (nao ha nada para
      vender la), mas escolhe-se a LINGUA que faz sentido para aquele
      pais. O visitante le na lingua dele; moeda e envio continuam a
      ser os do mercado por defeito.

   Travoes, por esta ordem:
     1. so corre uma vez por visitante (cookie pe_geo_done, 1 ano);
     2. nunca passa por cima de uma escolha manual (pe_lang_pref2);
     3. a via A so aceita paises que existem no seletor da loja;
     4. a via B so recarrega se a lingua for MESMO diferente, e marca
        o cookie ANTES de recarregar - sem isso entrava em ciclo;
     5. nao corre em pre-visualizacoes de tema nem no editor.

   v38 (velocidade): as duas vias ja nao recarregam a pagina sozinhas. Mostram um aviso
   (window.PE_localeHint, definido no layout/theme.liquid) e so mudam com o clique do cliente.

   COMO TESTAR: tem de ser na loja publicada (travao 5). Num pais que
   nao e' mercado, o que muda e' a LINGUA - a moeda nao muda, de
   proposito. */
(function () {
  var DONE = 'pe_geo_done';

  /* So estas seis linguas existem no seletor do tema. Qualquer pais
     fora do mapa cai em ingles - nunca em portugues, que era o
     defeito antigo. */
  var MAP = {
    PT:'pt-PT', BR:'pt-PT', AO:'pt-PT', MZ:'pt-PT', CV:'pt-PT',
    FR:'fr', BE:'fr', CH:'fr', LU:'fr', MC:'fr',
    DE:'de', AT:'de', LI:'de',
    ES:'es', MX:'es', AR:'es', CO:'es', CL:'es', PE:'es', UY:'es',
    IT:'it', SM:'it', VA:'it'
  };
  var FALLBACK = 'en';

  /* v38: textos do aviso (a pagina ja nao recarrega sozinha) */
  var LT = {
    de: ['Diese Seite gibt es auch auf Deutsch.', 'Auf Deutsch ansehen', 'Schließen'],
    fr: ['Cette page existe aussi en français.', 'Voir en français', 'Fermer'],
    it: ['Questa pagina è disponibile anche in italiano.', 'Vedi in italiano', 'Chiudi'],
    es: ['Esta página también está disponible en español.', 'Ver en español', 'Cerrar'],
    en: ['This page is also available in English.', 'View in English', 'Close'],
    pt: ['Esta página também está disponível em português.', 'Ver em português', 'Fechar']
  };
  var CT = {
    pt: ['País detetado', 'Ver preços e envio para este país?', 'Mudar de país', 'Fechar'],
    en: ['Detected country', 'See prices and delivery for this country?', 'Change country', 'Close'],
    de: ['Erkanntes Land', 'Preise und Versand für dieses Land anzeigen?', 'Land wechseln', 'Schließen'],
    fr: ['Pays détecté', 'Afficher les prix et la livraison pour ce pays ?', 'Changer de pays', 'Fermer'],
    es: ['País detectado', '¿Ver precios y envío para este país?', 'Cambiar de país', 'Cerrar'],
    it: ['Paese rilevato', 'Vedere prezzi e spedizione per questo paese?', 'Cambia paese', 'Chiudi']
  };

  function cookies() { return String(document.cookie || '').split(/;\s*/); }
  function has(n) {
    var c = cookies();
    for (var i = 0; i < c.length; i++) if (c[i].indexOf(n + '=') === 0) return true;
    return false;
  }
  function yearAhead() {
    var e = new Date();
    e.setFullYear(e.getFullYear() + 1);
    return e.toUTCString();
  }
  function mark() { document.cookie = DONE + '=1; path=/; expires=' + yearAhead(); }
  function rootDomain() {
    var p = location.hostname.split('.');
    return p.length > 2 ? p.slice(-2).join('.') : location.hostname;
  }

  /* 3BR (T4): so no tema publicado. Em pre-visualizacao a Shopify tira o
     preview_theme_id do URL a partir da 2.a pagina, mas Shopify.theme.role
     continua "unpublished"; sem informacao do tema, nao corre (prudente).
     Fica antes de tudo, para nao gravar pe_geo_done durante os testes. */
  var TH = window.Shopify && window.Shopify.theme;
  if (!TH || TH.role !== 'main') return;

  if (has(DONE)) return;
  if (has('pe_lang_pref2')) { mark(); return; }
  if (window.Shopify && window.Shopify.designMode) return;
  if (location.search.indexOf('preview_theme_id') > -1) return;

  var current = (window.Shopify && window.Shopify.country) || '';

  function available(code) {
    return !!document.querySelector('.country-option[value="' + code + '"]');
  }

  /* via A - trocar de mercado */
  function applyCountry(code) {
    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.style.display = 'none';
    function add(n, v) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = n; i.value = v;
      f.appendChild(i);
    }
    add('form_type', 'localization');
    add('utf8', '✓');
    add('country_code', code);
    add('return_to', '/' + location.pathname.replace(/^\/+/, '') + location.search);
    document.body.appendChild(f);
    f.submit();
  }

  /* via B - so a lingua. Escreve o mesmo cookie que o seletor do tema
     usa (pe_lang_pref2 = "<lingua>|<timestamp>"), lido pelo
     theme.liquid no <head> para montar o googtrans. */
  function applyLang(lang) {
    /* v37 (3BM): com o pais, porque a escolha so vale nesse pais */
    var val = encodeURIComponent(lang + '|' + Date.now() + '|' + String(current || '').toUpperCase());
    var exp = yearAhead();
    /* v37 (3BM): so no dominio inteiro, como no pe-region.js */
    document.cookie = 'pe_lang_pref2=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    try {
      document.cookie = 'pe_lang_pref2=' + val + ';path=/;domain=.' + rootDomain() +
                        ';expires=' + exp + ';SameSite=Lax';
    } catch (e) {}
  }

  function shortOf(v) { return String(v || '').toLowerCase().split('-')[0]; }

  function activeLang() {
    /* _PE_LANG e' definido pelo theme.liquid: vazio quando a pagina ja
       esta na lingua de origem, senao a lingua de destino. */
    if (window._PE_LANG) return window._PE_LANG;
    return document.documentElement.lang || 'en';
  }

  function run() {
    /* v27: nunca redirecionar/recarregar robots de pesquisa */
    if (/bot|crawl|spider|slurp|lighthouse|google-inspectiontool|bingpreview/i.test(navigator.userAgent)) return;
    (window.PE_geoFetch || fetch)('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        mark();                       /* marcar ANTES de qualquer recarga */
        if (!j) return;
        var d = j.detected_values || j;
        var c = d && d.country && (d.country.handle || d.country.iso_code || d.country.code);
        if (!c) return;
        c = String(c).toUpperCase();

        /* via A: o pais e' um mercado da loja */
        if (available(c)) {
          if (!current || c === String(current).toUpperCase()) return;
          /* v38 velocidade: ja nao muda de pais sozinho (recarregava a pagina) - mostra um aviso com botao */
          var pl = (document.documentElement.lang || 'en');
          var t = CT[shortOf(pl)] || CT.en;
          var cname = c;
          try { cname = new Intl.DisplayNames([pl], { type: 'region' }).of(c) || c; } catch (e) {}
          if (window.PE_localeHint) window.PE_localeHint({ lang: pl, text: t[0] + ': ' + cname + '. ' + t[1], btn: t[2], close: t[3], accept: function () { applyCountry(c); } });
          return;
        }

        /* via B: nao e' mercado - fica-se pela lingua */
        /* v39: para a Suica a lingua por defeito e' o frances. Se a pagina ja esta em frances
           nao ha aviso; em qualquer outra lingua (de, it, en, pt, es) aparece o aviso
           "Cette page existe aussi en francais" com botao - nunca muda sozinho. */
        if (c === 'CH' && shortOf(activeLang()) === 'fr') return;
        var want = MAP[c] || FALLBACK;
        if (shortOf(want) === shortOf(activeLang())) return;
        /* v38 velocidade: ja nao recarrega sozinho - mostra um aviso na lingua sugerida; o botao faz o que antes era automatico */
        var lt = LT[shortOf(want)] || LT.en;
        if (window.PE_localeHint) window.PE_localeHint({ lang: want, text: lt[0], btn: lt[1], close: lt[2], accept: function () { applyLang(want); location.reload(); } });
      })
      .catch(function () { mark(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
